import { callApi } from './callApi';

const avg = (list) => list.reduce((acc, v) => acc + v, 0) / list.length;

export function parseWaves(waves) {
  const segs = waves.split(',');
  const pos = segs.shift();
  //const steps = segs.filter((_, i) => i%2 === 0).map(p => Number(p));
  const prices = segs.filter((_, i) => i%2).map(p => Number(p));
  const p1 = avg(prices.filter((_, i) => i%2 === 0));
  const p2 = avg(prices.filter((_, i) => i%2 === 1));
  return {
    avgtop: (pos === '1' ? p1 : p2).toFixed(2),
    avgbot: (pos === '2' ? p1 : p2).toFixed(2),
  };
}

export function evalExpr(code, expr) {
  if (!code)
    Promise.reject('no code to evaluate expr');

  return isNaN(Number(expr)) ?
    callApi(`/stocks/eval?code=${code}&expr=${encodeURIComponent(expr)}`) :
    Promise.resolve({val: Number(expr)});
}

export function formatCompactDateRange(startDate, endDate) {
  const compactStart = String(startDate || '').slice(5);
  const compactEnd = String(endDate || '').slice(5);
  return compactStart && compactEnd ? `${compactStart} ~ ${compactEnd}` : '';
}
